module.exports = __webpack_public_path__ + "static/media/white_king.68d61822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pieces/white_king.png
// module id = 154
// module chunks = 0